module.exports = __webpack_public_path__ + "static/media/reactjs.e28cfeb5.png";